import APIService from '@/api'

export default class APINoteType extends APIService{

    constructor(){
        super('notetypes')
    }

    getAll() {
        var response = this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }
}


// WEBPACK FOOTER //
// ./src/api/notetype.js